import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { EngagementComponent } from './engagement.component';
import { EngagementRoutingModule } from './engagement-routing.module';
import { MyDatePickerModule } from 'mydatepicker';
import { ChatUiComponent } from './chat-history/chat-history.component';
import { ChatUiModule } from './chat-history/chat-history.module';
@NgModule({
    declarations: [
        EngagementComponent,
        
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GridModule,
        NgSelectModule,
        NgxUiLoaderModule,
        MaskedTextBoxModule,
        EngagementRoutingModule,
        MyDatePickerModule,
        ChatUiModule

    ],
    exports:[EngagementComponent ],
    providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService],
})
export class EngagementModule { }
